import { CSD_COLOR_VARIANTS, CSD_MESSAGES, CSD_TOOLTIP_MESSAGES } from '@/shared/constant';

type CsdScore = keyof typeof CSD_MESSAGES;
type CsdMessage = (typeof CSD_MESSAGES)[CsdScore];
type CsdColorVariants = {
  border: string;
  text: string;
};
export type CsdBadgeDetails = {
  colorVariants: CsdColorVariants;
  message: CsdMessage;
  tooltipMessage: string;
};

const DEFAULT_CSD_COLOR_VARIANTS: CsdColorVariants = {
  border: 'border-neutral-50',
  text: 'text-neutral-50',
};

export const getCsdColorVariants = (color: string): CsdColorVariants =>
  CSD_COLOR_VARIANTS[color as keyof typeof CSD_COLOR_VARIANTS] ?? DEFAULT_CSD_COLOR_VARIANTS;

export const getCsdColorClasses = (csdScore: CsdScore): string => {
  const { border, text } = getCsdColorVariants(CSD_MESSAGES[csdScore].color);

  return `${border} ${text}`;
};

export const getCsdBadgeDetails = (csdScore: null | number | undefined): CsdBadgeDetails | null => {
  if (!csdScore) {
    return null;
  }

  const message = CSD_MESSAGES[csdScore as keyof typeof CSD_MESSAGES];
  const tooltipMessage = CSD_TOOLTIP_MESSAGES[csdScore as keyof typeof CSD_TOOLTIP_MESSAGES];

  if (!message || !tooltipMessage) {
    return null;
  }

  return {
    colorVariants: getCsdColorVariants(message.color),
    message,
    tooltipMessage,
  };
};
